import { Route, Routes } from "react-router-dom";
import { Dash } from "./pages/dash";


export const App = () => {;

  return (
    <div className="h-[100vh] max-w-[100vw] dark">
      <Routes>
        <Route path="/" element={<Dash />} />
      </Routes>
    </div>
  );
}